<app-dynamic-text-widget [config]="config" [text]="text"></app-dynamic-text-widget>
